import { create } from "zustand";
import { NotificationStatus } from "../../interfaces/Commons/Notifications/notificationStatuses";


interface NotificationStatuses {
    notificationStatuses: NotificationStatus[];
    readStatus: NotificationStatus | null;
    unreadStatus: NotificationStatus | null;
    deleteStatus:NotificationStatus  | null;
    setNotificationStatuses: (by: NotificationStatus[]) => void;
    addNotificationStatus: (by: NotificationStatus) => void;
    setUnreadStatus: (status: NotificationStatus | null) => void;
    setReadStatus: (status: NotificationStatus | null) => void;
    setDeleteStatus: (status: NotificationStatus | null) => void;
}

export const useNotificationStatusStore = create<NotificationStatuses>((set,get)=> ({
    notificationStatuses: [],
    readStatus: null,
    unreadStatus: null,
    deleteStatus:null,
    setNotificationStatuses: (by: NotificationStatus[]) => {
        set({ notificationStatuses: by });
        // Buscar y establecer automáticamente los estados "Leído" y "No leído"
        const unreadStatus = by.find(status => status.notification_status_name === "No leído");
        const readStatus = by.find(status => status.notification_status_name === "Leído");
        const deleteStatus = by.find(status => status.notification_status_name === "Eliminado");
        set({ readStatus, unreadStatus, deleteStatus });
    },
    addNotificationStatus: (by: NotificationStatus) => {
        set((state) => ({ notificationStatuses: [...state.notificationStatuses, by] }));
        // Actualizar readStatus y unreadStatus si es necesario
        // if (by.notification_status_name === "Leído") {
        //     set({ readStatus: by });
        // } else if (by.notification_status_name === "No leído") {
        //     set({ unreadStatus: by });
        // } else if (by.notification_status_name === "Eliminado") {
        //     set({ deleteStatus: by });
        // }
    },
    setUnreadStatus: (status: NotificationStatus | null) => {
        set({ unreadStatus: status });
    },
    setReadStatus: (status: NotificationStatus | null) => {
        set({ readStatus: status });
    },
    setDeleteStatus: (status: NotificationStatus | null) => {
        set({deleteStatus : status});
    }
}));